/**
 *
 * @param WrappedComponent
 * @param cacheData {} 缓存的数据
 * @param cacheType:string 缓存的方式 localStorage / sessionStorage default: sessionStorage
 * @param cacheName:string 缓存的变量名
 * @returns
 */
function withPageDataCache(WrappedComponent, cacheType, cacheName) {
  function withCache(props) {
    // get cache and delete
    const getCache = () => {
      try {
        let cacheString =
          cacheType === 'localStorage'
            ? window.localStorage.getItem(cacheName)
            : window.sessionStorage.getItem(cacheName);
        if (cacheString) {
          let cacheObj = JSON.parse(cacheString);
          cacheType === 'localStorage'
            ? window.localStorage.removeItem(cacheName)
            : window.sessionStorage.removeItem(cacheName);
          return cacheObj;
        }
      } catch (error) {
        return {};
      }
    };
    // setCache
    const updateCache = setValue => {
      try {
        let cacheData = { ...setValue };
        cacheType === 'localStorage'
          ? window.localStorage.setItem(cacheName, JSON.stringify(cacheData))
          : window.sessionStorage.setItem(cacheName, JSON.stringify(cacheData));
      } catch (error) {}
    };

    return <WrappedComponent getCache={getCache} updateCache={updateCache} {...props} />;
  }
  if (WrappedComponent.GlobalComponent) {
    withCache.GlobalComponent = WrappedComponent.GlobalComponent;
  }

  return withCache;
}

export default withPageDataCache;
